import axios from './axiosConfig';
import { environment } from '../config/environment';
import {
  ICustomPushNotificationType,
  ICustomPushApiKey,
  ICustomPushApiKeyCreateResponse,
  ICustomPushNotificationLog,
  ICustomPushNotificationLogFilterData,
} from '../types/customPush';

export interface ICustomPushLogSearchParams {
  apiKeyId?: string;
  accountRef?: string;
  notificationType?: string;
  limit?: number;
  offset?: number;
}

export const customPushService = {
  getNotificationTypes: async (): Promise<ICustomPushNotificationType[]> => {
    const response = await axios.get<ICustomPushNotificationType[]>(
      `${environment.apiUrl}custompush/notificationtype`
    );
    return response.data;
  },

  createNotificationType: async (notificationType: string, description?: string): Promise<void> => {
    await axios.post(`${environment.apiUrl}custompush/notificationtype`, {
      notificationType,
      description,
    });
  },

  updateNotificationType: async (notificationType: string, description?: string): Promise<void> => {
    await axios.put(`${environment.apiUrl}custompush/notificationtype`, {
      notificationType,
      description,
    });
  },

  deactivateNotificationType: async (notificationType: string): Promise<void> => {
    await axios.delete(`${environment.apiUrl}custompush/notificationtype/${encodeURIComponent(notificationType)}`);
  },

  getApiKeys: async (): Promise<ICustomPushApiKey[]> => {
    const response = await axios.get<ICustomPushApiKey[]>(`${environment.apiUrl}custompush/apikey`);
    return response.data;
  },

  createApiKey: async (
    name: string,
    description: string | undefined,
    notificationTypes: string[],
    validFrom?: string,
    validUntil?: string
  ): Promise<ICustomPushApiKeyCreateResponse> => {
    const response = await axios.post<ICustomPushApiKeyCreateResponse>(`${environment.apiUrl}custompush/apikey`, {
      name,
      description,
      notificationTypes,
      validFrom,
      validUntil,
    });
    return response.data;
  },

  updateApiKey: async (
    apiKeyId: string,
    name: string,
    description: string | undefined,
    notificationTypes: string[],
    validFrom?: string,
    validUntil?: string
  ): Promise<void> => {
    await axios.put(`${environment.apiUrl}custompush/apikey`, {
      apiKeyId,
      name,
      description,
      notificationTypes,
      validFrom,
      validUntil,
    });
  },

  deactivateApiKey: async (apiKeyId: string): Promise<void> => {
    await axios.post(`${environment.apiUrl}custompush/apikey/${apiKeyId}/deactivate`);
  },

  deleteApiKey: async (apiKeyId: string): Promise<void> => {
    await axios.delete(`${environment.apiUrl}custompush/apikey/${apiKeyId}`);
  },

  getLogs: async (params: ICustomPushLogSearchParams): Promise<ICustomPushNotificationLog[]> => {
    const response = await axios.get<ICustomPushNotificationLog[]>(`${environment.apiUrl}custompush/log`, {
      params,
    });
    return response.data;
  },

  getLogFilterData: async (): Promise<ICustomPushNotificationLogFilterData> => {
    const response = await axios.get<ICustomPushNotificationLogFilterData>(
      `${environment.apiUrl}custompush/log/filterdata`
    );
    return response.data;
  },
};
